import { PaymentMethodType } from '../../payment-information';
import { BusinessModel } from './business-model';
import { ProductCategoryUpdate } from './context-update';
import { LicenseType } from './license-type';
import { ProductAddition } from './product-addition';
import { ProductIdentifier } from './product-identifier';
import { ProductLocalization } from './product-localization';
import { ProductPath } from './product-path';
import { PublishState } from './publish-state';
import { SaasApiConfigurationModel } from './saas-api-configuration-model';

export interface Product<T = Date> {
  additions: ProductAddition[];
  allowedPaymentMethods: PaymentMethodType[]; // Should be moved inside a PaymentMethodAddition
  businessModel: BusinessModel;
  fulfillmentCountry: string | null; // Should be moved inside B2C business model
  licenseTypes: LicenseType<T>[]; // Should be renamed and used as ContractSpecification including a PricingModel
  productCategoryUpdate: ProductCategoryUpdate<T>;
  productIdentifier: ProductIdentifier;
  productLocalization: ProductLocalization;
  productPaths: ProductPath[]; // Should be split and partially moved inside SoftwareProductContext
  publishState: PublishState;
  saasApiConfigurationModel: SaasApiConfigurationModel | null; // Should be moved inside SoftwareProductContext
  multipleActiveLicensesAllowed: boolean;
}
